var map = {
	"./scratch-cover.png": 108,
	"./scratch-cover@2x.png": 109
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 198;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/scratch\-cover.*\.png$
// module id = 198
// module chunks = 3